function finite(value, fallback = 0) {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
}

function clamp(value, minimum, maximum) {
  return Math.min(Math.max(value, minimum), Math.max(minimum, maximum));
}

export function placeAnchoredPopover({
  anchor,
  overlay,
  viewport,
  gap = 8,
  margin = 12,
  arrowMargin = 18,
} = {}) {
  if (!anchor || !overlay || !viewport) throw new TypeError('Popover geometry is incomplete.');
  const overlayWidth = Math.max(1, finite(overlay.width));
  const overlayHeight = Math.max(1, finite(overlay.height));
  const viewportWidth = Math.max(1, finite(viewport.width));
  const viewportHeight = Math.max(1, finite(viewport.height));
  const anchorLeft = finite(anchor.left);
  const anchorRight = finite(anchor.right, anchorLeft + finite(anchor.width));
  const anchorTop = finite(anchor.top);
  const anchorBottom = finite(anchor.bottom, anchorTop + finite(anchor.height));
  const anchorCenter = (anchorLeft + anchorRight) / 2;
  const left = clamp(anchorCenter - overlayWidth / 2, margin, viewportWidth - margin - overlayWidth);
  const spaceBelow = viewportHeight - anchorBottom - margin;
  const spaceAbove = anchorTop - margin;
  const placement = spaceBelow >= overlayHeight + gap || spaceBelow >= spaceAbove ? 'bottom' : 'top';
  const top = placement === 'bottom'
    ? clamp(anchorBottom + gap, margin, viewportHeight - margin - overlayHeight)
    : clamp(anchorTop - gap - overlayHeight, margin, viewportHeight - margin - overlayHeight);
  const arrowX = clamp(anchorCenter - left, arrowMargin, overlayWidth - arrowMargin);
  return { left, top, placement, arrowX };
}
